/**
 * 기출 회차 카드용 완주 뱃지 (JCG-2242).
 *
 * - 완주(completionCount > 0): 🏆 + 횟수 (violet/indigo "성취" 톤)
 * - 미완주(completionCount === 0): 빨간 "!" 뱃지
 *
 * FolderGrid(PostIcon)·PastExamIconGrid가 공유해 회차 카드 어디서나 동일하게 표시한다.
 * 호출처에서 프리미엄 여부(showCompletion)로 렌더를 게이팅한다.
 */
export default function RoundCompletionBadge({
  completionCount,
}: {
  completionCount: number;
}) {
  if (completionCount > 0) {
    return (
      <div
        className="min-w-5 h-5 px-1 bg-gradient-to-b from-violet-600 to-indigo-600 rounded-full flex items-center justify-center gap-0.5 shadow-sm ring-2 ring-background whitespace-nowrap"
        role="img"
        aria-label={`${completionCount}회 완주`}
      >
        <span className="text-[9px] leading-none select-none" aria-hidden="true">
          🏆
        </span>
        <span className="text-[10px] font-bold text-white leading-none select-none tracking-tight">
          {completionCount}
        </span>
      </div>
    );
  }
  return (
    <div
      className="w-5 h-5 bg-red-500 rounded-full flex items-center justify-center shadow-sm ring-2 ring-background"
      role="img"
      aria-label="미완주"
    >
      <span
        className="text-[10px] font-bold text-white leading-none select-none"
        aria-hidden="true"
      >
        !
      </span>
    </div>
  );
}
